module.exports = __webpack_public_path__ + "img/取信02.12ece701.svg";